export const CacheEntities = {
	terminal: 1,
	owner_company_data: 2,
	storage_module: 3,
};
